// extracted by mini-css-extract-plugin
module.exports = {"content":"products-module--content--1T4yi","anchorLinks":"products-module--anchorLinks--17vdX","anchorLink":"products-module--anchorLink--1ixfQ"};